import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export type CrossAppBridgeEvent =
  | {
      type: 'workspace.open';
      correlationId: string;
      tabKey?: string;
      eventId?: string | null;
      siteId?: string | null;
    }
  | {
      type: 'workspace.activate';
      correlationId: string;
      tabKey?: string;
    }
  | {
      type: 'workspace.close';
      correlationId: string;
      tabKey?: string;
    }
  | { type: 'session.logout' };

export interface CrossAppBridge {
  readonly events$: Observable<CrossAppBridgeEvent>;
  emit(event: CrossAppBridgeEvent): void;
}

export const CROSS_APP_BRIDGE = new InjectionToken<CrossAppBridge>('CROSS_APP_BRIDGE');
